var MONTH_PATTERN = /^\d{4}-\d{2}$/;
var DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

var FIELD_DEFS = {
  'currency-history': {
    uniqueColumn: 'month',
    fields: [
      { name: 'month', label: 'Month', type: 'month', required: true, keyField: true, help: 'Billing month (YYYY-MM)' },
      { name: 'usd', label: 'USD → USD', type: 'number', help: 'Rate from USD. USD itself is always 1.' },
      { name: 'gbp', label: 'USD → GBP', type: 'number' },
      { name: 'cad', label: 'USD → CAD', type: 'number' },
      { name: 'hkd', label: 'USD → HKD', type: 'number' },
      { name: 'eur', label: 'USD → EUR', type: 'number' },
      { name: 'aud', label: 'USD → AUD', type: 'number' },
      { name: 'chf', label: 'USD → CHF', type: 'number' },
      { name: 'jpy', label: 'USD → JPY', type: 'number' },
      { name: 'sgd', label: 'USD → SGD', type: 'number' }
    ]
  },
  'posting-months': {
    uniqueColumn: 'billing_month',
    fields: [
      { name: 'billing_month', label: 'Billing Month', type: 'month', required: true, keyField: true },
      { name: 'posting_date', label: 'Posting Date', type: 'date', required: true, help: 'Date invoices are posted/sent in Intacct' }
    ]
  },
  'nce-prices': {
    uniqueColumn: 'id',
    importOnly: true,
    fields: []
  },
  'intacct-mapping': {
    uniqueColumn: 'client_name',
    upsertNote: 'Adding a client name that already exists updates its row.',
    groups: [
      {
        title: 'Identity',
        fields: ['client_name', 'cust_name_clean', 'cust_name_match', 'parent_id']
      },
      {
        title: 'Billing Shape',
        fields: ['generate_bill', 'bill_split', 'locations', 'split_m365', 'split_azure', 'currencies', 'billing_entities']
      },
      {
        title: 'Intacct',
        fields: ['intacct_codes', 'class_id', 'entity_name', 'business_unit']
      },
      {
        title: 'Tax',
        fields: ['tax_type', 'tax_rate']
      }
    ],
    fields: [
      { name: 'client_name', label: 'Client Name', type: 'text', required: true, keyField: true, help: 'Exact processed-layer client name (customer_name_clean)' },
      { name: 'cust_name_clean', label: 'Clean Customer Name', type: 'text' },
      { name: 'cust_name_match', label: 'Customer Name Match', type: 'text' },
      { name: 'parent_id', label: 'Parent ID', type: 'text', max: 20 },
      { name: 'generate_bill', label: 'Generate Bill', type: 'boolean', default: true },
      { name: 'bill_split', label: 'Bill Split', type: 'select', options: ['Single', 'Split', 'zzTBD'], default: 'zzTBD' },
      { name: 'locations', label: 'Locations', type: 'text', help: 'Semicolon-separated, e.g. UK;US;HK' },
      { name: 'split_m365', label: 'Split % (M365)', type: 'text', help: 'Semicolon-separated percentages matching Locations' },
      { name: 'split_azure', label: 'Split % (Azure)', type: 'text', help: 'Semicolon-separated percentages matching Locations' },
      { name: 'currencies', label: 'Currencies', type: 'text', help: 'Semicolon-separated ISO codes matching Locations' },
      { name: 'billing_entities', label: 'Billing Entities', type: 'text', help: 'Semicolon-separated Intacct entities matching Locations' },
      { name: 'intacct_codes', label: 'Intacct Codes', type: 'text' },
      { name: 'class_id', label: 'Class ID', type: 'text', max: 10 },
      { name: 'entity_name', label: 'Entity Name', type: 'text' },
      { name: 'business_unit', label: 'Business Unit', type: 'text', max: 10 },
      { name: 'tax_type', label: 'Tax Type', type: 'text' },
      { name: 'tax_rate', label: 'Tax Rate', type: 'text', help: 'e.g. 20, 9, 0 — semicolon-separated when split' }
    ]
  },
  'billing-exclusions': {
    uniqueColumn: 'client_name',
    upsertNote: 'Adding a client name that already exists updates its row.',
    fields: [
      { name: 'client_name', label: 'Client Name', type: 'text', required: true, keyField: true, help: 'Exact processed-layer client name' },
      { name: 'm365_billing_start', label: 'M365 Billing Start', type: 'month', help: 'First month to bill (YYYY-MM). Blank = deliberately not billed' },
      { name: 'm365_billing_end', label: 'M365 Billing End', type: 'month', help: 'Last month to bill. Blank = bills forever after start' },
      { name: 'azure_billing_start', label: 'Azure Billing Start', type: 'month' },
      { name: 'azure_billing_end', label: 'Azure Billing End', type: 'month' },
      { name: 'opp_id', label: 'Opportunity ID', type: 'text' },
      { name: 'notes', label: 'Notes / No-Bill Reason', type: 'textarea' }
    ]
  },
  'license-adjustments': {
    uniqueColumn: 'id',
    fields: [
      { name: 'client_name', label: 'Client Name', type: 'text', required: true },
      { name: 'sku_name', label: 'SKU Name', type: 'text', required: true },
      { name: 'adjustment_amount', label: 'Adjustment Amount', type: 'number', required: true },
      { name: 'term', label: 'Term', type: 'text' },
      { name: 'start_month', label: 'Start Month', type: 'month' },
      { name: 'end_month', label: 'End Month', type: 'month' },
      { name: 'reason', label: 'Reason', type: 'text' },
      { name: 'removal_date', label: 'Removal Date', type: 'date' }
    ]
  },
  'license-exclusions': {
    uniqueColumn: 'id',
    fields: [
      { name: 'customer_id', label: 'Customer ID', type: 'text', required: true, help: 'Partner Center customer GUID' },
      { name: 'sku_name', label: 'SKU Name', type: 'text', required: true },
      { name: 'term', label: 'Term', type: 'text' },
      { name: 'reason', label: 'Reason', type: 'text' }
    ]
  },
  'azure-management-fees': {
    uniqueColumn: 'client_name',
    upsertNote: 'Adding a client name that already exists updates its row.',
    fields: [
      { name: 'client_name', label: 'Client Name', type: 'text', required: true, keyField: true },
      { name: 'fee_pct', label: 'Fee (fraction)', type: 'number', required: true, min: 0, max: 1, help: 'Stored as a decimal fraction: enter 0.05 for 5%. The workbook generator multiplies the Azure subtotal by this value.' },
      { name: 'min_fee', label: 'Minimum Fee', type: 'number' },
      { name: 'max_fee', label: 'Maximum Fee', type: 'number' },
      { name: 'start_month', label: 'Start Month', type: 'month' },
      { name: 'end_month', label: 'End Month', type: 'month' }
    ]
  },
  'azure-additional-services': {
    uniqueColumn: 'id',
    fields: [
      { name: 'client_name', label: 'Client Name', type: 'text', required: true },
      { name: 'service_name', label: 'Service Name', type: 'text', required: true },
      { name: 'description', label: 'Description', type: 'text' },
      { name: 'price', label: 'Price', type: 'number', required: true },
      { name: 'currency', label: 'Currency', type: 'text', required: true, length: 3, placeholder: 'USD' },
      { name: 'quantity', label: 'Quantity', type: 'number', default: 1 },
      { name: 'charge_type', label: 'Charge Type', type: 'text' },
      { name: 'start_month', label: 'Start Month', type: 'month' },
      { name: 'end_month', label: 'End Month', type: 'month' }
    ]
  },
  'invoice-memo-rules': {
    uniqueColumn: 'id',
    fields: [
      { name: 'client_name', label: 'Client Name', type: 'text', required: true, help: 'Exact processed-layer client name (e.g. TOR Investment)' },
      { name: 'applies_to', label: 'Applies To', type: 'select', options: ['intacct_memo', 'pdf_note', 'checklist'], required: true, help: 'intacct_memo = applied to the Intacct AR CSV; pdf_note/checklist = spot-check reminders only' },
      { name: 'rule', label: 'Rule', type: 'select', options: ['message_suffix', 'memo_suffix', 'pdf_note', 'checklist_note'], required: true, help: 'message_suffix appends to the invoice MESSAGE column (header row); memo_suffix appends to the line MEMO column (every row)' },
      { name: 'value', label: 'Value', type: 'text', help: 'Text appended, leading space included. Supports {fx:CCY} for the governed month FX rate, e.g. " (1USD = {fx:HKD}HKD)"' },
      { name: 'start_month', label: 'Start Month', type: 'month', help: 'First billing month the rule applies; blank = always' },
      { name: 'end_month', label: 'End Month', type: 'month', help: 'Last billing month; blank = no expiry' },
      { name: 'notes', label: 'Notes', type: 'textarea' }
    ]
  },
  'entity-map': {
    uniqueColumn: 'country',
    fields: [
      { name: 'country', label: 'Country', type: 'text', required: true, keyField: true },
      { name: 'entity', label: 'Intacct Entity', type: 'text', required: true },
      { name: 'msft_id', label: 'Microsoft ID', type: 'text' },
      { name: 'csp_region', label: 'CSP Region', type: 'text' }
    ]
  },
  'sku-renaming': {
    uniqueColumn: 'id',
    fields: [
      { name: 'trigger_type', label: 'Match On', type: 'select', options: ['ProductName', 'SkuName'], required: true },
      { name: 'trigger_value', label: 'Match Value', type: 'text', required: true },
      { name: 'clean_sku_name', label: 'Clean SKU Name', type: 'text', required: true }
    ]
  },
  'discounts': {
    uniqueColumn: 'id',
    fields: [
      { name: 'match_type', label: 'Match On', type: 'select', options: ['ProductName', 'SkuName'], required: true },
      { name: 'match_value', label: 'Match Value', type: 'text', required: true },
      { name: 'discount_pct', label: 'Discount %', type: 'number', required: true, min: 0, max: 100 }
    ]
  },
  'client-name-overrides': {
    uniqueColumn: 'id',
    fields: [
      { name: 'old_name', label: 'Old Name', type: 'text', required: true },
      { name: 'filter_column', label: 'Filter Column', type: 'text' },
      { name: 'filter_value', label: 'Filter Value', type: 'text' },
      { name: 'new_name', label: 'New Name', type: 'text', required: true }
    ]
  },
  'ns-customer-mapping': {
    uniqueColumn: 'customer_id',
    upsertNote: 'Adding a customer ID that already exists updates its row.',
    fields: [
      { name: 'customer_id', label: 'Customer ID', type: 'text', required: true, keyField: true, max: 20, help: 'Microsoft customer/tenant ID' },
      { name: 'customer_name', label: 'Customer Name', type: 'text', required: true },
      { name: 'parent_customer_id', label: 'Parent Customer ID', type: 'text', required: true, max: 20 },
      { name: 'parent_customer_name', label: 'Parent Customer Name', type: 'text', required: true }
    ]
  }
};

export function getFieldDefs(configKey) {
  return FIELD_DEFS[configKey] || null;
}

export function getUniqueColumn(configKey) {
  var def = FIELD_DEFS[configKey];
  return def && def.uniqueColumn ? def.uniqueColumn : 'id';
}

export function validateFieldValue(field, value) {
  if (field.required && (value === '' || value === null || value === undefined)) {
    return field.label + ' is required';
  }
  if (value === '' || value === null || value === undefined) return null;
  if (field.type === 'month' && !MONTH_PATTERN.test(value)) {
    return field.label + ' must be YYYY-MM';
  }
  if (field.type === 'date' && !DATE_PATTERN.test(value)) {
    return field.label + ' must be YYYY-MM-DD';
  }
  if (field.type === 'number') {
    var n = Number(value);
    if (isNaN(n)) return field.label + ' must be a number';
    if (field.min !== undefined && n < field.min) return field.label + ' must be at least ' + field.min;
    if (field.max !== undefined && n > field.max) return field.label + ' must be at most ' + field.max;
  }
  if (field.length && String(value).length !== field.length) {
    return field.label + ' must be exactly ' + field.length + ' characters';
  }
  if (field.max && field.type === 'text' && String(value).length > field.max) {
    return field.label + ' must be at most ' + field.max + ' characters';
  }
  return null;
}

export default FIELD_DEFS;
